import BAApi from '../ba/_baApi';
import httpClient from '@/apis/base/httpclient';
class SysUserAPI extends BAApi {
  constructor() {
    super();
  }
  controllerName = 'SysUsers';

  /**
   * Lấy dữ liệu danh sách
   * tvhien 28.11.2022
   */
  getUserRolePaging(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetUserRolePaging',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra quyền quản trị của người dùng hiện tại
   * API tự lấy thông tin user và đơn vị từ server
   * @returns {Promise} - Promise trả về true/false hoặc thông tin quyền
   */
  async checkAdminPermission() {
    let request = {
      url: this.getAPIUrl() + '/CheckAdminPermission',
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy tất cả danh sách quản lý người dùng
   * ncquyen 3.12.2022
   */
  async getAllUserRole(payload) {
    let request = {url: this.getAPIUrl() + '/GetAllUserRole', data: payload};
    return await httpClient.postAsync(request);
  }

  /**
   * custom lại hàm xóa để xóa những bảng liên quan (sys_user_role, database_user)
   * ncquyen 3.12.2022
   */
  async customDelete(payload) {
    let request = {
      url: this.getAPIUrl() + '/CustomDelete',
      data: payload,
    };

    return await httpClient.deleteAsync(request);
  }

  /**
   * Validate email, phone theo misaID
   * ncquyen 11/1/2023
   */
  async validateEmailPhone(payload) {
    let request = {
      url: this.getAPIUrl() + '/ValidateEmailPhone',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * Chuyển giao tài khoản
   * @param {*} payload
   * @returns
   */
  async AccountTransfer(payload) {
    let request = {url: this.getAPIUrl() + '/AccountTransfer', data: payload};
    return await httpClient.postAsync(request);
  }
  /**
   * Xác nhận người dùng tiếp tục sử dụng
   * NBTIN 13.03.2023
   */
  async confirmUser(payload) {
    let request = {
      url: this.getAPIUrl() + '/ConfirmUser',
      data: {...payload},
    };
    return await httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu grid xác nhận người dùng
   * NBTIN 22.03.2023
   */
  async getConfirmUserData(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetConfirmUserData',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }
  /**
   * Check xem có vượt quá số lượng người dùng
   * NBTIN 22.03.2023
   */
  async checkOverUser() {
    let request = {
      url: this.getAPIUrl() + '/CheckOverUser',
    };
    return await httpClient.postAsync(request);
  }
  /**
   * Lấy danh sách người dùng trong cùng đơn vị
   * dqdat1 21.11.2023
   */
  async getUsersTenant() {
    let request = {
      url: this.getAPIUrl() + '/UsersTenant',
    };
    return await httpClient.getAsync(request);
  }
  /**
   * Lấy danh sách người dùng được thiết lập bảo mật nâng cao trong cùng đơn vị
   * dqdat1 21.11.2023
   */
  async getUsersTenantAdvancedSecurity() {
    let request = {
      url: this.getAPIUrl() + '/UsersTenantAdvancedSecurity',
    };
    return await httpClient.getAsync(request);
  }
  /**
   * Lấy Trạng thái thiết lập bảo mật nâng cao trong cùng đơn vị
   * dqdat1 21.11.2023
   */
  async getTenantAdvancedSecurity() {
    let request = {
      url: this.getAPIUrl() + '/TenantAdvancedSecurity',
    };
    return await httpClient.getAsync(request);
  }
  /**
   * Cập nhật danh sách người dùng được thiết lập bảo mật nâng cao trong cùng đơn vị
   * dqdat1 21.11.2023
   */
  async updateUsersTenantAdvancedSecurity(payload) {
    let request = {
      url: this.getAPIUrl() + '/UsersTenantAdvancedSecurity',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }
  /**
   * Cập nhật danh sách người dùng được thiết lập bảo mật nâng cao trong cùng đơn vị
   * dqdat1 21.11.2023
   */
  async updateTenantAdvancedSecurity(payload) {
    let request = {
      url: this.getAPIUrl() + '/TenantAdvancedSecurity',
      data: payload,
    };
    return await httpClient.postAsync(request);
  }

  /**
   * Lấy thông tin người dùng trên tất cả các dữ liệu trong đơn vị
   * ntloc 24/4/2024
   */
  async getAllUserInTenant() {
    let request = {
      url: this.getAPIUrl() + '/GetAllUserInTenant',
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin license mới nhất
   * ntloc 16/5/2024
   */
  async getLicense(tenantId, budgetCode) {
    let request = {
      url: this.getAPIUrl() + '/Licenses',
      data: {tenantId, budgetCode},
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Lấy thông tin dữ liệu hết hạn theo mã đơn vị
   * @param {string} budgetCode - Mã đơn vị (budget code)
   * @returns {Promise} - Promise trả về danh sách ExpiredDataInformationEntity
   */
  async getExpiredDataInfoByBudgetCode(budgetCode) {
    let request = {
      url: this.getAPIUrl() + `/GetExpiredDataInfoByBudgetCode/${budgetCode}`,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Tải dữ liệu báo cáo, chứng từ hết hạn
   */
  downloadExpiredData(databaseId, tenantId, dataType) {
    let url = this.getAPIUrl() + `/DownloadExpiredData?databaseId=${databaseId}&tenantId=${tenantId}&app=${dataType}`;
    return url;
  }
}

export default new SysUserAPI();
